import React from 'react'
import { Spinner } from 'react-bootstrap/esm'

const LoadingSpinner = () => {
  return (
    <div className='custom_bg z-1 position-absolute start-0 top-0 vh-100 w-100 d-flex justify-content-center align-items-center'><Spinner/></div>
  )
}

export default LoadingSpinner